import { Jingle, UserState } from '../slices/local/user';
import { type ActionHandler } from '../middlewares/orchestrator';
import { type ChannelSelector, type ChannelState } from '../slices/local/orchestrator';
import { Span } from '@sentry/react';

export interface Progress {
  percent: number
  seconds: number
}

export abstract class Player {
  protected readonly selector: ChannelSelector;

  protected state?: ChannelState;

  protected userState?: UserState;

  protected actionQueue: ActionHandler[] = [];

  protected sentrySpan?: Span;

  constructor (selector: ChannelSelector) {
    this.selector = selector;
  }

  public setSentrySpan (sentrySpan: Span): void {
    if(this.sentrySpan !== undefined) {
      this.sentrySpan.end();
    }
    this.sentrySpan = sentrySpan;
  }

  protected trackEvent(event: string, data: any): void {
    if(this.sentrySpan === undefined)
      return;
    this.sentrySpan.addEvent(event, data);
  }

  public getActionQueue (): ActionHandler[] {
    return this.actionQueue;
  }

  public getSchedulerInterval (): number {
    return 5000;
  }

  public getMonitorInterval (): number {
    return 100;
  }

  public isMonitorEnabled (): boolean {
    return false;
  }

  public requiresDeferredStationChange (): boolean {
    return false;
  }

  public requiresDeferredVolumeChange (): boolean {
    return false;
  }

  public withState (state: ChannelState): this {
    this.state = state;
    return this;
  }

  public withUserState (userState: UserState): this {
    this.userState = userState;
    return this;
  }

  public pop (): ActionHandler | undefined {
    return this.actionQueue.shift();
  }

  public canBeStopped (): boolean {
    return true;
  }

  public monitor (): void {
    /* EMPTY */
  }

  public schedule (): void {
    /* EMPTY */
  }

  public changeStation (prevStationId: number): ActionHandler | undefined {
    return undefined;
  }

  public changeVolume (prevVolume: number, defer: boolean = false): ActionHandler | undefined {
    return undefined;
  }

  public mute (): void {
    /* EMPTY */
  }

  public unmute (): void {
    /* EMPTY */
  }

  public skip (): void {
    /* EMPTY */
  }

  public request (index: number): void {
    /* EMPTY */
  }

  public playJingle (jingle: Jingle | undefined, prevJingleId: number): ActionHandler | undefined {
    return undefined;
  }

  public stopJingle (prevJingleId: number): ActionHandler | undefined {
    return undefined;
  }

  public play (index: number, fromPosition: number = 0): void {
    /* EMPTY */
  }

  public stop (index: number): void {
    /* EMPTY */
  }

  public unload (index: number): void {
    /* EMPTY */
  }

  public progress (index: number): Progress {
    /* EMPTY */
    return {
      percent: 0.0,
      seconds: 0.0
    };
  }

  public downloaded (index: number): void {
    /* EMPTY */
  }
};
